{
  "clients": {
    "pageError": {
      "title": "Something went wrong while loading the page.",
      "tryAgain": "Try Again",
      "goHome": "Go to Home",
      "please": "Please"
    },
    "dashboard": {
      "statsTitle": "Clients",
      "activitiesTitle": "Last Updates",
      "draftsTitle": "Client Drafts"
    },
    "table": {
      "title": "Client Management",
      "search": "Search",
      "addButton": "Add New Client",
      "columns": {
        "name": "Name",
        "clientId": "Client ID",
        "clientCode": "Client Code",
        "mainContactEmail": "Main Contact Email",
        "isActive": "Is Active",
        "lastModified": "Last Modified",
        "actions": "Actions"
      },
      "emptyState": {
        "title": "No clients found.",
        "descriptionWithSearch": "Try adjusting your search criteria.",
        "descriptionNoData": "There are no clients to display at this time."
      },
      "actions": {
        "view": "View client",
        "edit": "Edit client",
        "copy": "Copy"
      }
    }
  }
}
